import React from 'react';
import classNames from 'classnames';

const WorkspaceIcon = ({
  className, size, ...rest
}) => (
  <svg className={classNames(`w-${size} h-${size}`, className)} aria-label="workspace" viewBox="0 0 100 100" {...rest}>
    <g>
      <path d="M23.2,33l2.4,2.4L44.1,16.8l-2.4-2.4a13.1,13.1,0,0,0-18.5,0H8.9V46.1H5.4V92.9h6v-30H87.1v30h6V46.1H73.8V41.9H94.6V7.1H47V41.9H67.8v4.2H14.9V20.4h4.9A12.8,12.8,0,0,0,23.2,33ZM53,35.9V13.1H88.6V35.9H53ZM73.8,52.1H87.1v4.8H11.4V52.1H73.8ZM27.4,18.7h0a7.1,7.1,0,0,1,7.9-1.4l-9.4,9.3A7.1,7.1,0,0,1,27.4,18.7Z" />
    </g>
  </svg>
)

export default WorkspaceIcon;
